import React from 'react'
import Loader from './Loader.jsx'

export default function FirstLoadGate({ children }) {
  const force = new URLSearchParams(window.location.search).get('forceLoader') === '1'

  // Per your requirement: show the intro every time the site is loaded/reloaded.
  // (You can skip it for dev with ?skipLoader=1)
  const skip = new URLSearchParams(window.location.search).get('skipLoader') === '1'
  const [show, setShow] = React.useState(() => force || (!skip))

  if (!show) return children

  return (
    <Loader
      onDone={() => {
        setShow(false)
      }}
    >
      {children}
    </Loader>
  )
}
